import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
  const equipeCarousels = document.querySelectorAll(".equipe-carousel");

  if (equipeCarousels) {
    equipeCarousels.forEach(function (carousel) {
      const splide = new Splide(carousel, {
        type: "loop",
        perPage: 1,
        perMove: 1,
        gap: "16px",
        arrows: false,
        pagination: true,
        mediaQuery: "min",
        breakpoints: {
          768: {
            perPage: 2,
            pagination: false,
            gap: "32px",
          },
          992: {
            perPage: 3,
            pagination: false,
            gap: "32px",
          },
        },
      });

      splide.mount();

      // Bind custom arrows scoped to this block
      const block = carousel.closest(".equipe-block");
      if (!block) return;

      const prevBtn = block.querySelector(".equipe-arrow--prev");
      const nextBtn = block.querySelector(".equipe-arrow--next");

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          splide.go("<");
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          splide.go(">");
        });
      }
    });
  }
});
